module.exports = __webpack_public_path__ + "img/defence-academy-24.f34f1ac6.svg";